module.exports = __webpack_public_path__ + "static/media/may-win.a1ca02bc.png";